const projects = {
  "myPageModal": {
    "menuLabel": "マイページメニュー",
    "account": {
      "editField": "{{field}}を編集",
      "saveField": "{{field}}を保存",
      "cancelEdit": "{{field}}の編集をキャンセル",
      "saving": "保存中",
      "requiredError": "値を入力してください。",
      "phoneError": "電話番号の形式が正しくありません。",
      "emptyValue": "値なし"
    },
    "logout": {
      "message": "ログアウトしますか？",
      "signingOut": "ログアウト中"
    },
    "withdrawal": {
      "description": "以下の案内を確認して同意してください。",
      "processing": "処理中",
      "ownedProjectNotice": "プロジェクトを所有している場合は退会できません。プロジェクトを削除するか、所有権を他のメンバーに移転してから退会してください。",
      "retentionNotice": "退会すると、氏名やメールアドレスなどのアカウント情報は直ちに削除され、元に戻せません。参加したプロジェクトに残した課題・コメント・写真・計測記録は他のメンバーのためにプロジェクトに残り、作成者は「{{unknownLabel}}」と表示されます。",
      "retryNotice": "アカウント情報は削除されましたが、ログインアカウントの削除が完了していません。もう一度「{{confirmLabel}}」を押して完了してください。"
    },
    "permission": {
      "members": "メンバー",
      "memberList": "メンバー一覧",
      "roleGroup": "{{name}}の権限",
      "deleteMember": "{{name}}を削除",
      "noChanges": "変更なし",
      "changeCount": "変更 {{count}}件",
      "noMembers": "メンバーがいません",
      "deleteTitle": "メンバー削除",
      "deleteMessage": "メンバー「{{name}}」を削除しますか？",
      "deleteSubMessage": "削除したメンバーは元に戻せません",
      "emailLabel": "メールアドレス",
      "emailRequired": "メールアドレスを入力してください。",
      "emailInvalid": "メールアドレスの形式が正しくありません。もう一度ご確認ください。",
      "emailExists": "既に存在するメールアドレスです。",
      "serverError": "サーバーエラーです。管理者にお問い合わせください。",
      "adding": "追加中",
      "resetDone": "変更内容をリセットしました。",
      "noOwnProjectTitle": "オーナー(owner)として登録されたプロジェクトがありません",
      "noOwnProjectDescription": "プロジェクト権限の管理はオーナーのみ行えます。",
      "transfer": {
        "title": "所有権の移転",
        "warning": "移転するとこのプロジェクトの所有権は新しいオーナーに移り、あなたはこのプロジェクトから外れます。元に戻せません。",
        "emailLabel": "新しいオーナーのメール",
        "submit": "移転",
        "transferring": "移転中",
        "notFound": "メールが未登録または退会済みか、あなたはすでにこのプロジェクトのオーナーではありません。",
        "titleConflict": "新しいオーナーが同じ名前のプロジェクトをすでに持っているため、移転できません。プロジェクト名を変更してから再度お試しください。",
        "invalidTarget": "自分自身や管理者アカウントには移転できないか、リクエストの形式が正しくありません。",
        "failed": "所有権の移転に失敗しました。しばらくしてからもう一度お試しください。"
      }
    },
    "select": {
      "noResult": "検索結果がありません"
    },
    "history": {
      "timeline": "プロジェクト履歴",
      "loadingMore": "読み込み中"
    }
  },
  "queryState": {
    "projectListLoadFailed": "プロジェクト一覧を読み込めませんでした",
    "ownProjectListLoadFailed": "所有プロジェクト一覧を読み込めませんでした",
    "memberListLoadFailed": "メンバー一覧を読み込めませんでした",
    "droneImageListLoadFailed": "ドローン画像一覧を読み込めませんでした",
    "droneImageSizeLoadFailed": "ドローン画像の原本サイズを読み込めませんでした",
    "gcpFileLoadFailed": "GCPファイル情報を読み込めませんでした",
    "layerDataLoadFailed": "ファイル一覧を読み込めませんでした",
    "layerDataLoadFailedNamed": "{{name}} のファイル一覧を読み込めませんでした",
    "drawingListLoadFailed": "図面一覧を読み込めませんでした",
    "drawingListLoadFailedNamed": "{{name}}の一覧を読み込めませんでした",
    "orthomosaicImageLoadFailed": "オルソ画像プレビューを読み込めませんでした",
    "earthworkZoneListLoadFailed": "計算領域の一覧を読み込めませんでした",
    "earthworkSurfaceListLoadFailed": "図面と設計サーフェスの一覧を読み込めませんでした",
    "earthworkSurfaceNameLoadFailed": "サーフェス名を読み込めませんでした",
    "earthworkEpochListLoadFailed": "時系列一覧を読み込めませんでした",
    "earthworkPermissionLoadFailed": "プロジェクト権限情報を読み込めませんでした",
    "earthworkPermissionChecking": "プロジェクト権限を確認しています",
    "earthworkProjectLoadFailed": "プロジェクト情報を読み込めませんでした",
    "earthworkResultLoadFailed": "土工算出結果を読み込めませんでした",
    "earthworkStartFailed": "土工算出を開始できませんでした",
  },
  "earthwork": {
    "noSiteDrawingTitle": "このプロジェクトには団地土工用の図面がありません",
    "noSiteDrawingHint": "図面が団地用に指定され変換が完了した後、ページを再読み込みするとここに表示されます。",
    "computeUnavailable": "団地土工用の図面がないため、土工量を計算できません。",
    "sidebarDisabled": {
      "noEarthworkSource": "このプロジェクトには土工に使う団地図面も線形レイヤーもないため開けません",
      "sourceUnreadable": "図面またはレイヤーの一覧を読み込めなかったため開けません",
      "needsCompletedTimeSeries": "開くには完了した時系列を選択してください",
      "timeSeriesUnreadable": "時系列一覧を読み込めなかったため開けません",
      "checking": "開けるか確認しています",
      "meshNotBuilt": "3D(メッシュ)がまだ構築されていないため開けません",
      "twoDNotBuilt": "2D(オルソ画像 · DEM)がまだ構築されていないため開けません"
    }
  },
  "drawingBundle": {
    "expand": "バンドルを展開",
    "collapse": "バンドルを折りたたむ",
    "memberCount": "図面{{count}}件",
    "expanding": "バンドルを展開中",
    "failed": "バンドルの展開に失敗しました",
    "pending": "変換待ち {{count}}件",
    "uploaded": "束 {{name}} をアップロードしました — 図面 {{count}}件を登録、変換が終わると束の中に表示されます",
    "uploadFailed": "束 {{name}} のアップロードに失敗しました — {{reason}}",
    "nameInput": "バンドル名を入力"
  },
  "drawingPair": {
    "title": "設計図アップロード",
    "hint": "図面ごとに整列 DXF が 1 つ必要です。",
    "drawingColumn": "図面",
    "alignmentColumn": "整列 DXF",
    "alignmentMissing": "整列 DXF なし",
    "pickAlignment": "{{name}} の整列 DXF を選択",
    "pick": "選択",
    "replace": "変更",
    "unpairedCount": "整列 DXF がない図面 {{count}}件",
    "orphanNotice": "対応が見つからない DXF: {{names}}",
    "submit": "アップロード",
    "submitLabel": "設計図ペアをアップロード",
    "submitBlockedLabel": "整列 DXF がない図面が {{count}}件 — アップロードできません",
    "cancel": "キャンセル",
    "close": "閉じる",
    "dwgRequired": "図面(.dwg)ファイルがありません。図面と整列 DXF を一緒に選択してください。",
    "lonelyDxfSkipped": "対応する図面(.dwg)がない DXF {{count}}件はアップロードしませんでした。",
    "alignmentUploadFailed": "整列 DXF のアップロードに失敗しました — {{names}}",
    "gapTitle": "整列が空のままの図面 {{count}}件",
    "gapDescription": "図面はアップロードされましたが整列 DXF が空です。整列が空だとビルドできません。",
    "retry": "整列を再アップロード",
    "retryLabel": "整列 DXF を再アップロード"
  },
  "sidebar": {
    "timeSeries": "時系列点検",
    "calendar": "カレンダー",
    "road": "道路舗装",
    "graph": "グラフ",
    "ship": "船舶"
  },
  "menu": {
    "timeSeries": "時系列点検",
    "roadDetection": "道路舗装問題検出"
  },
  "dashboard": {
    "title": "プロジェクト",
    "searchPlaceholder": "プロジェクト検索",
    "noProjects": "プロジェクトがありません",
    "noSearchedTags": "一致するタグがありません",
    "loading": "読み込み中...",
    "countLoading": "件数を確認中",
    "filterApplied": "フィルター、{{count}}件適用中",
    "tagFilter": "タグフィルター"
  },
  "modal": {
    "addProject": "プロジェクト追加",
    "editTimeSeries": "時系列修正",
    "editProject": "プロジェクト情報の編集",
    "steps": {
      "location": "位置",
      "projectInfo": "プロジェクト情報",
      "addTimeSeries": "時系列追加"
    },
    "projectName": "プロジェクト名",
    "projectNamePlaceholder": "プロジェクト名を入力してください",
    "address": "住所",
    "location": "位置",
    "changeLocation": "変更",
    "addressSearchPlaceholder": "住所を検索するか地図をクリック",
    "infraType": "インフラタイプ",
    "infraTypeInputPlaceholder": "インフラタイプを入力してください",
    "objectType": "オブジェクトタイプ",
    "selectPlaceholder": "選択してください",
    "objectTypeExample": "例: 橋梁",
    "tags": "タグ",
    "tagsPlaceholder": "タグを選択するか新しく追加(Enter)してください",
    "memo": "メモ",
    "memoPlaceholder": "メモを入力してください",
    "datePlaceholder": "日付を選択してください",
    "comment": "コメント",
    "commentPlaceholder": "コメントを入力してください",
    "required": "&#42;",
    "cancel": "キャンセル",
    "next": "次へ",
    "previous": "前へ",
    "save": "保存",
    "add": "追加",
    "apply": "適用",
    "feedback": {
      "projectCreated": "プロジェクト作成完了",
      "projectCreateFailed": "プロジェクト作成失敗",
      "duplicateProjectName": "既に同じプロジェクト名が存在します。",
      "timeSeriesOwnerOnly": "時系列の追加・編集はプロジェクトのオーナーのみ可能です。"
    },
    "state": {
      "addressSearchFailed": "住所の検索結果を読み込めませんでした",
      "addressNoResult": "検索結果がありません",
      "projectInfoLoadFailed": "プロジェクト情報を読み込めませんでした",
      "timeSeriesInfoLoadFailed": "時系列情報を読み込めませんでした"
    },
    "a11y": {
      "stepProgress": "進行ステップ",
      "reselectInfraType": "インフラタイプを選び直す",
      "removeTag": "タグ「{{tag}}」を外す",
      "adding": "追加中",
      "saving": "保存中",
      "addressSearching": "住所を検索中",
      "addressResults": "住所の検索結果",
      "tagsLoading": "タグを読み込み中",
      "tagList": "タグ一覧",
      "projectInfoLoading": "プロジェクト情報を読み込み中",
      "timeSeriesInfoLoading": "時系列情報を読み込み中"
    }
  },
  "table": {
    "columns": {
      "name": "プロジェクト名",
      "location": "位置",
      "date": "日付",
      "status": "状態",
      "actions": "作業",
      "memo": "メモ",
      "mappingStatus": "画像マッピング状態",
      "timeSeriesCount": "時系列"
    },
    "status": {
      "completed": "完了",
      "processing": "処理中",
      "pending": "待機中",
      "failed": "失敗"
    },
    "addTimeSeries": "時系列追加",
    "createNewProject": "新しいプロジェクトを作成してください。",
    "lastModified": "最近修正日",
    "memoSearch": "メモ検索",
    "noMemoResults": "検索されたメモがありません",
    "noSearchResult": "検索結果がありません",
    "listLoading": "プロジェクト一覧を読み込み中",
    "searching": "検索中"
  },
  "details": {
    "title": "プロジェクト詳細",
    "information": "プロジェクト情報",
    "timeSeries": "時系列データ",
    "noData": "データがありません",
    "projectName": "プロジェクト名",
    "location": "位置",
    "createdAt": "作成日",
    "updatedAt": "修正日",
    "description": "説明",
    "unknown": "不明"
  },
  "map": {
    "title": "プロジェクト位置",
    "noLocation": "位置情報がありません",
    "preview": "位置プレビュー"
  },
  "tabs": {
    "information": "情報",
    "droneImage": "ドローン画像",
    "layerData": "レイヤーデータ",
    "terrainData": "地形高度データ",
    "referenceData": "参考データ"
  },
  "information": {
    "details": "詳細情報",
    "edit": "修正",
    "address": "住所",
    "coordinates": "緯度経度",
    "latitude": "緯度",
    "longitude": "経度",
    "infraType": "インフラ/オブジェクトタイプ",
    "tags": "タグ",
    "memo": "メモ",
    "thumbnail": "サムネイル",
    "noImage": "画像なし",
    "noPreviewTarget": "プレビューを取得する時系列がありません"
  },
  "layerTypes": {
    "stratum": "地層",
    "designHeight": "計画高",
    "designProfile": "原地盤高",
    "drawing": "設計図"
  },
  "dataTypes": {
    "image": "画像",
    "document": "文書",
    "video": "ビデオ",
    "gis": "GIS",
    "line": "線形Layer",
    "bim": "BIM",
    "pointCloud": "Point Cloud"
  },
  "droneImage": {
    "selectAll": "全て選択",
    "uploadedImages": "アップロードされた画像",
    "uploadingImages": "アップロード中の画像",
    "targetImages": "アップロード対象画像",
    "totalSize": "総容量",
    "uploadImages": "画像アップロード",
    "uploadImagesCount": "画像アップロード",
    "uploading": "アップロード中",
    "uploadingMessage": "送信完了まで現在の画面を維持してください",
    "uploadSuccess": "画像アップロードが完了しました。",
    "uploadFailed": "画像アップロードに失敗しました。",
    "deleteSuccess": "画像の削除が完了しました。",
    "deleteFailed": "画像の削除に失敗しました。",
    "deleting": "削除中...",
    "loading": "読み込み中...",
    "noValidImages": "有効な画像ファイル(.jpg, .jpeg)がありません。",
    "addImagesGuide": "画像追加タブで画像を追加"
  },
  "file": {
    "download": "ダウンロード",
    "delete": "削除",
    "upload": "アップロード",
    "refresh": "更新",
    "downloadNamed": "{{name}} をダウンロード",
    "deleteNamed": "{{name}} を削除",
    "uploadNamed": "{{name}} をアップロード",
    "previewNamed": "{{name}} をプレビュー",
    "deleteSuccess": "ファイルの削除が完了しました。",
    "deleteFailed": "ファイルの削除に失敗しました。",
    "downloadFailed": "ファイルのダウンロードに失敗しました。",
    "uploading": "アップロード中",
    "uploadingMessage": "送信完了まで現在の画面を維持してください",
    "skippedUnsupported": "対応していない形式のファイル {{count}}件を除外しました。"
  },
  "layerRename": {
    "renameLayer": "名前を変更",
    "renameLayerNamed": "{{name}} の名前を変更",
    "layerNameInput": "レイヤー名を入力",
    "renameDuplicate": "既に使用されている名前です。別の名前を入力してください。",
    "renameInvalid": "使用できない名前です。名前は1～100文字である必要があります。",
    "renameNoPermission": "名前を変更する権限がないか、対象が見つかりません。",
    "renameFailed": "レイヤー名の変更に失敗しました。"
  },
  "timeSeries": {
    "mappingInfo": "マッピング情報",
    "imageMapping": "画像マッピング",
    "mappingRequest": "マッピングリクエスト",
    "requestCompleted": "リクエスト完了",
    "gcpUpload": "GCPアップロード",
    "gcp": "GCP",
    "gcpAutoDetect": "自動認識",
    "gcpAutoDetectHint": "DroneSquare標準マーカーを設置したGCPの場合にオンにしてください。GCPファイルをアップロードした後にオンにできます。",
    "gcpAutoDetectSaveFailed": "GCP自動認識の設定を変更できませんでした。",
    "gcpAutoDetectBlocked": {
      "GCP_FILE_UNREADABLE": "$t(timeSeries.gcpGuide.unreadableFormats)ファイルは自動認識で読み込めません。csvまたはxlsxで保存して、もう一度アップロードしてください。",
      "NO_PHOTOS": "ドローン写真をアップロードすると、自動認識をオンにできます。"
    },
    "gcpFilesUsedTogether": "GCPファイルが複数ある場合は、すべてまとめて使用します。",
    "autoBuild": {
      "inProgressTitle": "自動処理中",
      "phase": {
        "waiting": "1/3 待機 — 処理サーバーの順番を待っています。",
        "processing": "2/3 処理 — 写真とGCPを受け取り、成果物を作成しています。",
        "publishing": "3/3 結果反映 — 作成した成果物をアップロードしています。"
      },
      "phaseUnknown": "自動構築で処理しています。",
      "completed": "自動構築で完了",
      "handedOverTitle": "自動構築に代わって担当者が処理します",
      "reasonUnknown": "担当者が引き続き処理します。",
      "reasons": {
        "markers": {
          "what": "マーカーを十分に見つけられなかったか、マーカーが撮影範囲を均等にカバーしていませんでした。",
          "nextTime": "次回は、GSD {{gcpGsdLimitCm}} cm以下になるよう低く飛行し、影のない場所にマーカーを6つ以上(最低5つ)撮影範囲の隅まで均等に置いてください。GCPファイルにはマーカーを設置した点だけを記載します。"
        },
        "gcp_file": {
          "what": "GCPファイルを読み込めなかったか、座標が撮影範囲と合いませんでした。",
          "nextTime": "次回は、$t(timeSeries.gcpGuide.readableFormats)ファイルに1行ずつラベル・X・Y・ZをEPSG:5185~5188の座標で記載してアップロードしてください。"
        },
        "photos": {
          "what": "写真が自動構築の条件を満たしていませんでした。",
          "nextTime": "次回は、対応機体($t(timeSeries.gcpGuide.allowedAircraft))でRTK Fixの状態で、広角RGBカメラ1台のみ、オーバーラップ進行方向65%・横方向60%以上で撮影してください。"
        },
        "accuracy": {
          "what": "整合結果が精度の基準を満たしませんでした。",
          "nextTime": "次回は、マーカーの中心を測量したか、高さが正標高(KNGeoid)基準かを確認してください。"
        },
        "internal": {
          "what": "処理サーバーの事情により自動構築を完了できませんでした。",
          "nextTime": "次回もそのまま自動認識をお使いいただけます。"
        }
      }
    },
    "autoBuildRejected": {
      "AUTO_BUILD_UNAVAILABLE": "この環境では自動構築を使用しません。",
      "AUTO_DETECT_OFF": "自動認識がオフのため、自動構築を依頼できません。GCP行の[$t(timeSeries.gcpAutoDetect)]をオンにしてから再度依頼してください。",
      "GCP_FILE_MISSING": "GCPファイルがないため、自動構築を使用できません。GCP行でGCPファイルをアップロードしてください。",
      "GCP_FILE_UNREADABLE": "自動構築が読み込めないGCPファイルがあります。$t(timeSeries.gcpGuide.readableFormats)で保存して再度アップロードしてください。",
      "NO_PHOTOS": "ドローン写真がないため、自動構築を使用できません。",
      "AUTO_DETECT_LOCKED": "マッピングを依頼した後は自動認識を変更できません。",
      "NO_RGB_PHOTOS": "自動構築が処理できるRGB写真がありません(熱画像か読み込めない写真のみです)。今回は[$t(timeSeries.gcpAutoDetect)]なしで依頼すると担当者が処理します。撮影条件は「$t(timeSeries.gcpGuide.title)」にあります。",
      "MULTI_SENSOR": "複数のカメラで撮影した写真が混在しているため、自動構築を使用できません(広角RGBカメラ1台で撮影した写真のみ受け付けます)。今回は[$t(timeSeries.gcpAutoDetect)]なしで依頼すると担当者が処理します。撮影条件は「$t(timeSeries.gcpGuide.title)」にあります。",
      "DRONE_UNSUPPORTED": "自動構築が対応していない機体で撮影した写真です。対応機体は$t(timeSeries.gcpGuide.allowedAircraft)です。今回は[$t(timeSeries.gcpAutoDetect)]なしで依頼すると担当者が処理します。撮影条件は「$t(timeSeries.gcpGuide.title)」にあります。",
      "NO_GNSS": "EXIFにGNSS位置がない写真があるため、自動構築を使用できません。今回は[$t(timeSeries.gcpAutoDetect)]なしで依頼すると担当者が処理します。撮影条件は「$t(timeSeries.gcpGuide.title)」にあります。",
      "RTK_NOT_FIXED": "RTK Fixの状態で撮影していない写真があるため、自動構築を使用できません。今回は[$t(timeSeries.gcpAutoDetect)]なしで依頼すると担当者が処理します。撮影条件は「$t(timeSeries.gcpGuide.title)」にあります。"
    },
    "autoBuildRejectedUnknown": "このデータには自動構築を使用できません。[$t(timeSeries.gcpAutoDetect)]なしで依頼すると担当者が処理します。",
    "mappingRequestResult": {
      "succeeded": "マッピングの依頼が完了しました。",
      "alreadyRequested": "すでにマッピングを依頼済みか、処理中の回です。",
      "failed": "マッピングの依頼に失敗しました。"
    },
    "mappingAutoBuildNotice": "GCP自動認識がオンのため、マッピングは自動で進行します。",
    "mappingRequestModal": {
      "title": "画像マッピングをリクエストしますか?",
      "description": "マッピングをリクエストしたプロジェクトでは、画像リストから画像を削除したり、追加でアップロードしたりできません。",
      "confirm": "リクエスト",
      "autoBuildConditions": "下記の条件を1つでも満たさない場合は担当者が処理するため、時間がかかります。",
      "turnOnAutoDetect": "DroneSquare標準マーカーを設置して撮影した場合は、GCP行の[$t(timeSeries.gcpAutoDetect)]をオンにしてからリクエストしてください。",
      "manualThisTime": "今回のリクエストは担当者が処理します。"
    },
    "gcpGuide": {
      "open": "$t(timeSeries.gcpGuide.title)",
      "title": "GCP自動認識ガイド",
      "aircraft": {
        "m3e": "Mavic 3E",
        "m4": "Matrice 4E/4D",
        "p4rtk": "Phantom 4 RTK",
        "p1_35": "Zenmuse P1 35 mm"
      },
      "allowedAircraft": "$t(timeSeries.gcpGuide.aircraft.m3e)・$t(timeSeries.gcpGuide.aircraft.m4)・$t(timeSeries.gcpGuide.aircraft.p4rtk)・$t(timeSeries.gcpGuide.aircraft.p1_35)",
      "readableFormats": "csv・txt・xlsx",
      "unreadableFormats": "xls",
      "what": {
        "title": "自動認識とは",
        "items": [
          "GCPの位置にDroneSquare標準マーカーを設置して撮影すると、システムが写真からマーカーを見つけてGCPを自動で合わせます。写真ごとにGCPを指定する必要はありません。"
        ]
      },
      "checklist": {
        "title": "自動処理の条件",
        "items": [
          "DroneSquare標準マーカー(一辺{{gcpMarkerSideCm}} cm)を5つ以上均等に設置し、設置した日にマーカーの中心を測量します。",
          "DJIのRTK機体($t(timeSeries.gcpGuide.allowedAircraft))でRTK Fixの状態で、広角RGBカメラ1台で撮影します。",
          "地上解像度(GSD){{gcpGsdLimitCm}} cm以下で撮影します。",
          "GCPファイル($t(timeSeries.gcpGuide.readableFormats))には、今回マーカーを設置した点だけを記載します。",
          "高さ(Z)は正標高(KNGeoid)で記載します。"
        ]
      },
      "prepare": {
        "title": "マーカーの準備",
        "printFile": "100%の倍率で{{gcpMarkerSideMm}} × {{gcpMarkerSideMm}} mm(仕上がり線基準)に合わせて印刷してください。",
        "previewAlt": "DroneSquare標準マーカーのプレビュー — 左上と右下のマスが黒い2×2の白黒チェッカーの正方形の板",
        "downloadPdf": "PDFをダウンロード",
        "downloadSvg": "SVGをダウンロード",
        "downloadA1": "A1分割PDFをダウンロード",
        "a1Note": "A1用紙2枚に分けて印刷し、貼り合わせるファイルです。",
        "items": [
          "一辺{{gcpMarkerSideCm}} cmの白黒2×2チェッカーです。左上・右下のマスが黒で、縁と番号はありません。マットを推奨します。",
          "同じ模様の市販の{{gcpMarkerSideCm}} cmの板も使えます。縁や番号があるもの、模様が違うものは使えません。",
          "自分で作る場合は、マットの横断幕に印刷し、四隅に固定用のハトメを付けます。GCPの数だけ用意します。"
        ]
      },
      "install": {
        "title": "設置と測量",
        "items": [
          "マーカーを設置した日に、マーカーの中心(2つの黒いマスが接する点)を測量します。",
          "平らに広げて四隅を固定し、水気・ほこり・影のない場所に置きます。",
          "6つ以上(最低5つ)を撮影範囲の隅まで均等に置きます。マーカーが囲む面積が撮影範囲の30%より小さいと、自動処理されません。",
          "(任意)検証点を置く場合は、GCPファイルに基準点をGCP1・GCP2…、検証点をCP1・CP2…と記載します。"
        ]
      },
      "flight": {
        "title": "撮影",
        "itemsBeforeTable": [
          "GSD {{gcpGsdLimitCm}} cm以下で撮影します。{{gcpGsdFalloffCm}} cmを超えるとマーカーを見つけにくくなり、担当者の処理に回りやすくなります。"
        ],
        "tableCaption": "GSD {{gcpGsdLimitCm}} cmとなるおおよその高度(対地、飛行アプリのGSDで確認)",
        "tableHeaders": {
          "aircraft": "機体",
          "altitude": "対地高度"
        },
        "tableRows": {
          "m3e": "$t(timeSeries.gcpGuide.aircraft.m3e)・$t(timeSeries.gcpGuide.aircraft.m4)",
          "p4rtk": "$t(timeSeries.gcpGuide.aircraft.p4rtk)",
          "p1_35": "$t(timeSeries.gcpGuide.aircraft.p1_35)"
        },
        "tableAltitude": "約{{meters}} m",
        "validatedRangeNote": "{{aircraft}}:{{meters}} mまで検証済みの高度です。",
        "itemsAfterTable": [
          "オーバーラップは進行方向65%・横方向60%以上にします。",
          "マーカーごとに、写真5枚以上に全体が写るようにします。"
        ]
      },
      "upload": {
        "title": "アップロードと依頼",
        "items": [
          "写真とGCPファイルをいつもどおりアップロードし、GCP行の[$t(timeSeries.gcpAutoDetect)]をオンにしてからマッピングを依頼します。",
          "GCPファイルは$t(timeSeries.gcpGuide.readableFormats)のみ読み込めます($t(timeSeries.gcpGuide.unreadableFormats)は読み込めません)。1行にラベル、X、Y、Zを記載し、座標系はEPSG:5185~5188です。X・Yの順序はどちらでも構いません。",
          "高さには、現場のTBM・基本水準面(DL)・楕円体高を基準とする値を使いません。",
          "GCPファイルは回ごとにアップロードします(前回と同じでも)。"
        ]
      },
      "fallback": {
        "title": "自動処理されない場合",
        "items": [
          "マーカーを十分に見つけられない場合や品質の基準に届かない場合は、担当者が従来の方法で処理します。",
          "成果物の品質は同じで、お客様の対応は不要です。"
        ]
      }
    },
    "completionDate": "完了日",
    "coordinateSystem": "出力座標系",
    "resolution": "解像度(GSD)",
    "images": "画像(最適化/原本)",
    "download": "ダウンロード",
    "preview": "プレビュー",
    "orthomosaic": "オルソモザイク画像[TIF]",
    "pointCloud": "3D点群[LAS]",
    "mesh": "3Dメッシュ[OBJ]",
    "meshZip": "3Dメッシュ[OBJ](.zip)",
    "dsm": "数値表面モデル[DSM-TIF]",
    "dsmZip": "数値表面モデル[DSM-TIF](.zip)",
    "orthoDownload": {
      "optionsName": "成果物のダウンロードオプション",
      "loadFailed": "成果物のダウンロードオプションを読み込めませんでした",
      "remainingOf": "残り回数 {{remaining}} / {{limit}}",
      "products": {
        "orthomosaic": "オルソモザイク画像",
        "dsm": "数値表面モデル [DSM-TIF]"
      },
      "files": {
        "dsmGeotiff": "DSM GeoTIFF(.tif)"
      },
      "unavailable": "なし",
      "unavailableNotice": "この回次にはこのファイルがありません。必要な場合は担当者にお問い合わせください。",
      "geotiffGroup": "GeoTIFF(GIS 用)",
      "cadGroup": "CAD パッケージ(AutoCAD・Civil 3D 用)",
      "geotiffHelpLabel": "GeoTIFF の説明",
      "cadHelpLabel": "CAD パッケージの説明",
      "geotiffHelp": "原本は解像度が高いためファイルが大きく、開くのに多くのメモリが必要です。必要な解像度と PC の性能に合わせて、1/2・1/4 縮小版を受け取ることをおすすめします。\n\n縮小版は最初に要求したときに一度だけ作成され、画像の大きさによっては数分以上かかることがあります。一度作成された後はすぐに受け取れ、作成は回数を消費しません。",
      "cadHelp": "PNG・ワールドファイル(.pgw)・座標系(.prj)・DXF(画像・標高点・標高ラベル)・標高点 CSV(Civil 3D COGO 点)を含む ZIP です。解凍して DXF を開くと画像が実際の座標位置に合わせて自動的に表示されるため、位置や大きさを別途合わせる必要はありません。\n\n標高点の高さは DSM です。建物・樹木・機材の上を含む表面の高さで、単位は正標高 m です。画像が透明、または DSM が空の場所には点がありません。\n\nCAD パッケージは最初に要求したときに一度だけ作成され、時間がかかることがあります。",
      "elevationSpacingNotice": "この回次は撮影範囲が広いため、標高点を {{spacing}} m 間隔で配置します(既定 5 m)。",
      "optionLabel": "{{cm}} cm/px({{variant}})",
      "variantOriginal": "原本",
      "variantScaled": "1/{{scale}} 縮小",
      "pixels": "{{width}} × {{height}} px",
      "notGenerated": "未生成",
      "generate": "生成",
      "generateFor": "生成: {{option}}",
      "download": "ダウンロード",
      "downloadFor": "ダウンロード: {{option}}",
      "processing": "生成中",
      "processingFor": "生成中: {{option}}",
      "processingProgress": "生成中 {{progress}}%",
      "failed": "生成失敗",
      "ownerOnly": "成果物のダウンロードはプロジェクトのオーナーと管理者アカウントのみ可能です。",
      "limitExhausted": "ダウンロード回数をすべて使い切りました。追加のダウンロードは担当者にご連絡ください。",
      "notReady": "このオプションはまだ準備できていません。状態を再読み込みしました。",
      "concurrencyLimit": "進行中の生成が多いため、今は開始できません。しばらくしてからもう一度お試しください。",
      "requestFailed": "ダウンロード要求に失敗しました。もう一度お試しください。",
      "confirm": {
        "title": "ダウンロードの確認",
        "largeImageWarning": "この画像は約 {{megapixels}} MP(1 億ピクセル超)です。ファイルが非常に大きく、開くには多くのメモリが必要です。",
        "originalSlowNotice": "PC の性能とオルソモザイク画像の容量によってはダウンロードが遅くなることがあります。ご不便な場合は別途ご連絡ください。",
        "largeFileWarning": "このファイルは {{size}} です。ダウンロードに時間がかかり、同じだけの空き容量が必要です。",
        "cancel": "キャンセル",
        "download": "ダウンロード"
      }
    }
  },
  "myPage": {
    "title": "マイページ",
    "logout": "ログアウト",
    "menu": {
      "accountInfo": "アカウント情報",
      "projectPermission": "プロジェクト権限管理",
      "projectHistory": "プロジェクト履歴",
      "withdrawal": "退会"
    },
    "account": {
      "title": "アカウント情報",
      "name": "名前",
      "email": "メールアドレス",
      "organization": "所属",
      "phone": "携帯電話番号",
      "field": "分野",
      "role": "職務",
      "password": "パスワード",
      "passwordConfirm": "パスワード確認",
      "currentPassword": "現在のパスワード",
      "newPassword": "新しいパスワード",
      "changePassword": "パスワード変更",
      "save": "保存",
      "cancel": "キャンセル",
      "edit": "修正",
      "timezone": "表示タイムゾーン",
      "timezoneAutoDetected": "(ブラウザ自動検出)"
    },
    "permission": {
      "title": "プロジェクト権限管理",
      "addUser": "ユーザー追加",
      "searchUser": "ユーザー検索",
      "userEmail": "ユーザーメールアドレス",
      "permission": "権限",
      "role": {
        "owner": "オーナー",
        "editor": "編集者",
        "viewer": "ビューア"
      },
      "status": {
        "joined": "加入",
        "notJoined": "未加入"
      },
      "actions": {
        "delete": "削除",
        "edit": "修正",
        "add": "追加"
      },
      "table": {
        "email": "メールアドレス",
        "name": "名前",
        "permission": "権限",
        "status": "加入状態",
        "actions": "作業"
      }
    },
    "withdrawal": {
      "title": "退会",
      "confirm": "退会を確認する",
      "cancel": "キャンセル"
    },
    "messages": {
      "passwordChanged": "パスワードが変更されました",
      "passwordChangeFailed": "パスワードの変更に失敗しました",
      "accountUpdated": "アカウント情報が修正されました",
      "accountUpdateFailed": "アカウント情報の修正に失敗しました",
      "userAdded": "ユーザーが追加されました",
      "userAddFailed": "ユーザーの追加に失敗しました",
      "userDeleted": "ユーザーが削除されました",
      "userDeleteFailed": "ユーザーの削除に失敗しました",
      "permissionUpdated": "権限が修正されました",
      "permissionUpdateFailed": "権限の修正に失敗しました",
      "accountDeleteFailed": "アカウントの削除に失敗しました",
      "ownerTransferred": "所有権を移転しました",
      "confirmDelete": "本当に削除しますか？",
      "confirmWithdrawal": "本当に退会しますか？",
      "projectInfoUpdated": "プロジェクト情報が修正されました",
      "projectInfoUpdateFailed": "プロジェクト情報の修正に失敗しました",
      "timeSeriesUpdated": "時系列情報が修正されました",
      "timeSeriesUpdateFailed": "時系列情報の修正に失敗しました",
      "reset": "初期化"
    },
    "history": {
      "sentence": {
        "create": "{{actor}}さんが{{target}}を追加しました",
        "register": "{{actor}}さんが{{target}}を登録しました",
        "update": "{{actor}}さんが{{type}}を「{{name}}」に修正しました",
        "delete": "{{actor}}さんが{{target}}を削除しました",
        "generic": "{{actor}} · {{target}}",
        "memberWithdrawn": "{{actor}}さんが退会によりプロジェクトから離れました"
      },
      "type": {
        "project": "プロジェクト",
        "time_project": "時系列",
        "member": "メンバー",
        "annotation": "アノテーション",
        "annotation_comment": "コメント",
        "annotation_comment_image": "コメント画像",
        "category": "カテゴリ",
        "vector": "3D測定",
        "clipping": "3D断面",
        "worksite_zone": "立入禁止区域",
        "geolog": "ジオログ",
        "walk_session": "徒歩撮影",
        "layer": "レイヤー",
        "drawing_mesh": "設計図",
        "folder": "フォルダ",
        "project_equipment": "機材・施設",
        "height_profile_record": "縦断面区間",
        "height_profile_export": "縦断面エクスポート"
      },
      "name": {
        "timeProject": "撮影日 {{name}}",
        "walkSession": "セッション {{name}}"
      },
      "timeProjectFallback": "時系列 #{{id}}",
      "empty": "記録がありません",
      "emptyFiltered": "この種類の記録はありません",
      "noProject": "所属しているプロジェクトがありません",
      "forbidden": "このプロジェクトの記録を閲覧する権限がありません",
      "error": "記録を読み込めませんでした",
      "retry": "再試行",
      "loadMore": "さらに読み込む"
    }
  },
  "fileList": {
    "dragAndDrop": "ファイルをドラッグ＆ドロップしてください",
    "or": "または",
    "selectFile": "ファイル選択"
  },
  "status": {
    "before": "処理前",
    "requested": "リクエスト完了",
    "onProcessing": "処理中",
    "failed": "処理失敗",
    "reviewing": "検収中",
    "completed": "処理完了",
    "completed2d": "2D完了",
    "completed3d": "3D完了"
  },
  "droneImageTabs": {
    "list": "アップロード完了リスト",
    "add": "画像追加"
  },
  "projectPermission": {
    "selectProject": "プロジェクト選択",
    "addMember": "メンバー追加",
    "saveChanges": "保存",
    "resetChanges": "初期化",
    "loading": "プロジェクト一覧を読み込み中...",
    "transferOwner": "所有権の移転"
  }
} as const;

export default projects;
